import React from "react";
import { Line, LineChart, ResponsiveContainer, YAxis, XAxis } from "recharts";
import { useIsXXLMediaQuery } from "@app/hooks";
import { ChartData } from "../../types";
import { CHART_SETTINGS } from "./constants";
import { generateTicks } from "./utils";

type Props = {
  series: ChartData[];
};

export const Chart: React.FC<Props> = ({ series }) => {
  const isXXLScreen = useIsXXLMediaQuery();

  return (
    <ResponsiveContainer
      height={
        isXXLScreen
          ? CHART_SETTINGS.largeScreen.height
          : CHART_SETTINGS.mobile.height
      }
      width="100%"
    >
      <LineChart
        width={500}
        height={
          isXXLScreen
            ? CHART_SETTINGS.largeScreen.height
            : CHART_SETTINGS.mobile.height
        }
        data={series}
      >
        <YAxis
          orientation="left"
          axisLine={false}
          width={30}
          domain={["dataMin", "dataMax"]}
          type="number"
          tickFormatter={(tick) => Math.round(Number(tick)).toString()}
          stroke="#999999"
          tickLine={false}
          scale={"auto"}
          ticks={generateTicks(series, 5)}
        />
        <XAxis
          dataKey="date"
          tickLine={false}
          scale={"auto"}
          angle={-45}
          tickMargin={
            isXXLScreen
              ? CHART_SETTINGS.largeScreen.xAxis.tickMargin
              : CHART_SETTINGS.mobile.xAxis.tickMargin
          }
          tick={({ x, y, payload, index }) => {
            const totalTicks = series.length;

            if (index === totalTicks - 1) return null;

            return (
              <text
                x={x}
                y={y}
                textAnchor="end"
                fill="#999999"
                fontSize={
                  isXXLScreen
                    ? CHART_SETTINGS.largeScreen.xAxis.fontSize
                    : CHART_SETTINGS.mobile.xAxis.fontSize
                }
                transform={`rotate(-45 ${x},${y})`}
                style={{ overflow: "visible" }}
              >
                {payload.value}
              </text>
            );
          }}
          height={
            isXXLScreen
              ? CHART_SETTINGS.largeScreen.xAxis.height
              : CHART_SETTINGS.mobile.xAxis.height
          }
          allowDataOverflow
          stroke="#ffffff"
          axisLine={false}
        />
        <Line
          type="monotone"
          dataKey="alpian"
          stroke="#FFFFFF"
          strokeWidth={2}
          dot={false}
        />
        <Line
          type="monotone"
          dataKey="morningstarMarkets"
          stroke="#663F83"
          strokeWidth={2}
          dot={false}
        />
        <Line
          type="monotone"
          dataKey="morningstarCore"
          stroke="#2B4387"
          strokeWidth={2}
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
